import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class LifeInfo extends BaseModel {
    @Expose() afp = "";
    @Expose() startRentPayment = "";
    @Expose() paymentMethod = "";
    @Expose() paymentFrecuency = "";
}
